import { HUBSPOT_EVENTS } from './constants';
import { hubSpotMethods } from './hubSpotMethods';
import { SendVideoFeedbackEventData } from './types';

const MISC_EVENTS = {
  downloadVideo: () => {
    hubSpotMethods.trackEvent(HUBSPOT_EVENTS.downloadVideo);
  },

  pricingPageShown: () => {
    hubSpotMethods.trackEvent(HUBSPOT_EVENTS.pricingPageShown);
  },

  sendVideoFeedback: ({ event, user_id }: SendVideoFeedbackEventData) => {
    hubSpotMethods.trackEvent(event, { user_id });
  },

  editorApplyChanges: () => {
    hubSpotMethods.trackEvent(HUBSPOT_EVENTS.editorApplyChanges);
  },

  clickOnLockedFeature: (feature: string) => {
    hubSpotMethods.trackEvent(HUBSPOT_EVENTS.clickOnLockedFeature, { feature });
  },
};

export const HubSpotEvents = {
  ...MISC_EVENTS,
};
